import { mutations as flowMutations, types as flowMutationTypes } from "./flow";
import {
  mutations as basketMutations,
  types as basketMutationTypes
} from "./basket";

export default {
  flowMutations,
  flowMutationTypes,
  basketMutations,
  basketMutationTypes
};
